import { SanitizedRichText, Text } from '@shared/ui';

// Legacy bodies have no MIME discriminator. Require a document, an explicit line break,
// or a paired formatting tag; a lone <name> or an email address remains ordinary text.
const legacyHtmlPattern =
  /<!doctype\s+html\b|<(?:html|body)\b[^>]*>|<br\s*\/?\s*>|<(p|div|span|table|tr|td|th|a|b|strong|i|em|blockquote|ul|ol|li|h[1-6])\b[^>]*>[\s\S]*?<\/\1\s*>/iu;

export function HelpdeskMessageBody({ description }: { description: string | null }) {
  if (description && legacyHtmlPattern.test(description)) {
    return (
      <Text as="div">
        <SanitizedRichText html={description} preserveBlockBoundaries />
      </Text>
    );
  }
  return <Text className="whitespace-pre-wrap break-words">{description}</Text>;
}
